import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { DateTimeService } from "../../shared/datetime/datetime.service";
import { BizDataGridDirective } from "../../shared/grid/biz-grid.directive";
import { TrackingService } from "../services/tracking.service";
import { DxDataGridModule } from "devextreme-angular";
import { DxiColumnModule } from "devextreme-angular/ui/nested";

@Component({
    selector: 'app-status-events-detail-grid',
    templateUrl: './status-events-detail-grid.component.html',
    styleUrls: ['./status-events-detail-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, DxiColumnModule]
})

export class StatusEventsDetailGridComponent implements AfterViewInit  {

    constructor(private trackingService: TrackingService, public dateTimeService: DateTimeService,) { }

    dataSourceItems: any[] = [];

    @ViewChild(BizDataGridDirective, { static: true }) private datagrid: BizDataGridDirective;

    @Input() statusEventSubscriptionRunId: any;

    ngAfterViewInit() {
        this.trackingService.getStatusEventLogs(this.statusEventSubscriptionRunId).then((result) => {
            this.dataSourceItems = result;
        });
    }
}